export const COMPANY = {
  name: "Excellent Traders Pte Ltd",
  shortName: "Excellent Traders",
  address: "60 Paya Lebar Road, Paya Lebar Square 1, #06-28, Singapore 409051",
  addressLines: ["60 Paya Lebar Road", "Paya Lebar Square 1, #06-28", "Singapore 409051"],
  email: "victor@excellentraders.com",
  logo: "/assets/logo.webp",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/bitumen", label: "Bitumen" },
  { to: "/lubricants", label: "Lubricants" },
  { to: "/petrochemicals", label: "Petrochemicals" },
  { to: "/contact", label: "Contact" },
];

export const PRODUCT_DOMAINS = ["Bitumen", "Lubricants", "Petrochemicals", "General Commodity"];
